import React from 'react'

import {
  useEnableV2FeedPage,
  useEnableCmeCollection,
  useEnforceAlgoliaQuestionSearchInAutoComplete,
  useQuestionSearchAlgorithm,
  useShowNewSearchModal,
} from 'mednet-cns/src/hooks/gregorFlags'

// camelCase `flags` object for class components; extend as more classes migrate.
export const useGregorFlags = () => ({
  enableV2FeedPage: useEnableV2FeedPage(),
  enableCmeCollection: useEnableCmeCollection(),
  enforceAlgoliaQuestionSearchInAutoComplete:
    useEnforceAlgoliaQuestionSearchInAutoComplete(),
  questionSearchAlgorithm: useQuestionSearchAlgorithm(),
  showNewSearchModal: useShowNewSearchModal(),
})

// Drop-in replacement for withLDConsumer(): injects `flags` into class components.
export const withGregorFlags = (WrappedComponent) => {
  const WithGregorFlags = (props) => {
    const flags = useGregorFlags()
    return <WrappedComponent {...props} flags={flags} />
  }

  WithGregorFlags.displayName = `withGregorFlags(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`

  return WithGregorFlags
}
